import {useMemo} from 'react';
import {Navigate, useRoutes} from 'react-router-dom';
import {LayoutDashboard, Boxes, Users, KeyRound, Wallet, Headset, Bell, Settings} from 'lucide-react';
import {PrivateRoute} from './route/PrivateRoute';
import {VisaoRoute} from './route/VisaoRoute';
import {VISOES_DO_PORTAL} from '../shared/auth/portalAccess';
import {LoginPage} from '../features/Login/LoginPage';
import PortalDashboardPage from '../features/Dashboard/PortalDashboardPage';
import FinanceiroPage from '../features/Financeiro/FinanceiroPage';
import FaturaPage from '../features/Financeiro/FaturaPage';
import LicencasPage from '../features/Licencas/LicencasPage';
import EmptyPortalPage from '../features/Shared/EmptyPortalPage';
import SistemasPage from '../features/Sistemas/SistemasPage';
import UsuariosPage from '../features/Usuarios/UsuariosPage';
import ConfiguracoesPage from '../features/Configuracoes/ConfiguracoesPage';

export default function App() {
    const routes = useMemo(() => ([
        {path: '/login', element: <LoginPage />},
        {path: '/', element: <PrivateRoute><PortalDashboardPage /></PrivateRoute>},
        {path: '/sistemas', element: <PrivateRoute><SistemasPage /></PrivateRoute>},
        // Áreas com visão do portal (BBF-175): sem a visão, a pessoa vê um aviso no lugar da página.
        {path: '/usuarios', element: <PrivateRoute><VisaoRoute visao={VISOES_DO_PORTAL.USUARIOS_E_PERFIS}><UsuariosPage /></VisaoRoute></PrivateRoute>},
        {path: '/licencas', element: <PrivateRoute><VisaoRoute visao={VISOES_DO_PORTAL.LICENCAS}><LicencasPage /></VisaoRoute></PrivateRoute>},
        {path: '/financeiro', element: <PrivateRoute><VisaoRoute visao={VISOES_DO_PORTAL.FINANCEIRA}><FinanceiroPage /></VisaoRoute></PrivateRoute>},
        {path: '/financeiro/:faturaId', element: <PrivateRoute><VisaoRoute visao={VISOES_DO_PORTAL.FINANCEIRA}><FaturaPage /></VisaoRoute></PrivateRoute>},
        {path: '/chamados', element: <PrivateRoute><VisaoRoute visao={VISOES_DO_PORTAL.SUPORTE}><EmptyPortalPage title="Chamados" description="Abertura e acompanhamento de chamados entram na próxima trilha de entrega." /></VisaoRoute></PrivateRoute>},
        {path: '/notificacoes', element: <PrivateRoute><EmptyPortalPage title="Notificações" description="Central de notificações prevista para as próximas iterações." /></PrivateRoute>},
        {path: '/configuracoes', element: <PrivateRoute><ConfiguracoesPage /></PrivateRoute>},
        {path: '*', element: <Navigate to="/" replace />},
    ]), []);

    return useRoutes(routes);
}

export const portalMenuFactory = (navigate) => ([
    {id: 'dashboard', label: 'Dashboard', path: '/', icon: <LayoutDashboard size={18} />, onClick: () => navigate('/')},
    {id: 'sistemas', label: 'Sistemas', path: '/sistemas', icon: <Boxes size={18} />, onClick: () => navigate('/sistemas')},
    {id: 'usuarios', label: 'Usuários', path: '/usuarios', icon: <Users size={18} />, onClick: () => navigate('/usuarios')},
    {id: 'licencas', label: 'Licenças', path: '/licencas', icon: <KeyRound size={18} />, onClick: () => navigate('/licencas')},
    {id: 'financeiro', label: 'Financeiro', path: '/financeiro', icon: <Wallet size={18} />, onClick: () => navigate('/financeiro')},
    {id: 'chamados', label: 'Chamados', path: '/chamados', icon: <Headset size={18} />, badge: 3, onClick: () => navigate('/chamados')},
    {id: 'notificacoes', label: 'Notificações', path: '/notificacoes', icon: <Bell size={18} />, badge: 5, onClick: () => navigate('/notificacoes')},
    {id: 'configuracoes', label: 'Configurações', path: '/configuracoes', icon: <Settings size={18} />, onClick: () => navigate('/configuracoes')},
]);
